import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BidItem {
  id?: string;
  name: string;
  drafterUuid: string;
  topBid: number;
  topBidderUuid: string;
  purchasedFor?: number;
  purchasedByUuid?: string;
  completed: boolean;
}

@Injectable({ providedIn: 'root' })
export class BidItemService {
  private injector = inject(EnvironmentInjector);

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  constructor(private db: AngularFireDatabase) {}

  addBidItem(item: BidItem) {
    return this.inCtx(() => this.db.list('/bidItems').push(item));
  }

  updateBidItem(id: string, item: Partial<BidItem>) {
    return this.inCtx(() => this.db.object(`/bidItems/${id}`).update(item));
  }

  getCurrentBidItem(): Observable<BidItem[]> {
    return this.inCtx(() => this.db.list<BidItem>('/bidItems', ref => ref.orderByChild('completed').equalTo(false)).valueChanges());
  }

  getAllBidItems(): Observable<BidItem[]> {
    return this.inCtx(() => this.db.list<BidItem>('/bidItems').valueChanges());
  }

  getCurrentBidItemWithKeys(): Observable<BidItem[]> {
    return this.inCtx(() => this.db.list<BidItem>('/bidItems', ref => ref.orderByChild('completed').equalTo(false))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => ({ id: a.key, ...(a.payload.val() as BidItem) })))
      ));
  }

  getAllBidItemsWithKeys(): Observable<BidItem[]> {
    return this.inCtx(() => this.db.list<BidItem>('/bidItems')
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => ({ id: a.key, ...(a.payload.val() as BidItem) })))
      ));
  }
}
